import contractVersions from 'modules/contracts/store/collections/contractVersions'
import {
  peopleManagedByEmployee,
  peopleTimeoffManagedByEmployee,
} from 'modules/employees/store/collections/employeesContractVersions'

import { type Memberships } from './collections/memberships'
import { type Teams } from './collections/teams'
import { teamsLedByEmployee } from './teamsLedByEmployee'

// This is about being deprecated in favor of using permissions
// Use permissions instead
export const userIsManagingPeople = (
  teams: Teams,
  memberships: Memberships,
  employeeId: number | undefined
) => {
  if (employeeId === undefined) {
    return false
  }

  const teamsLedBy = teamsLedByEmployee(teams, memberships, employeeId)
  const managedBy = peopleManagedByEmployee(employeeId, contractVersions)
  const timeoffManagedBy = peopleTimeoffManagedByEmployee(employeeId, contractVersions)

  return teamsLedBy.length > 0 || managedBy.length > 0 || timeoffManagedBy.length > 0
}
